import DePayWidgets from "@depay/widgets"
import PaymentLink from '../payment-link'
import React from "react"
import { createRoot } from "react-dom/client"

window.DePayWidgets = DePayWidgets // expose to mock in tests

let root

document.addEventListener('DOMContentLoaded', () => {
  const element = document.getElementById('payment-link')
  
  if(root){ root.unmount() }

  root = createRoot(element)

  root.render(
    <PaymentLink
      country={ element.dataset['country'] }
      email={ element.dataset['email'] }
      name={ element.dataset['name'] }
      quantity={ element.dataset['quantity'] }
    />
  )
})
